import React, { useState, useEffect } from "react";
import { Box, IconButton, TextField } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import DialogConfirmWrapper from "components/DialogConfirmWrapper";
import { useTranslation } from "react-i18next";

const socialPlatforms = [
  { key: "facebook", icon: FacebookIcon, color: "#1877F2", placeholder: "https://facebook.com/yourpage" },
  { key: "linkedin", icon: LinkedInIcon, color: "#0A66C2", placeholder: "https://linkedin.com/yourpage" },
  { key: "instagram", icon: InstagramIcon, color: "#E4405F", placeholder: "https://instagram.com/yourpage" },
  { key: "X", icon: XIcon, color: "#000", placeholder: "https://x.com/yourpage" },
];

const SocialMediaDialog = ({
  open,
  onClose,
  onConfirm,
  initialIcons = [],
  initialLinks = {},
}) => {
  const [selectedIcons, setSelectedIcons] = useState({});
  const [tempLinks, setTempLinks] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    if (open) {
      const iconsObject = {};
      (initialIcons || []).forEach((key) => {
        iconsObject[key] = true;
      });
      setSelectedIcons(iconsObject);
      setTempLinks(initialLinks || {});
    }
  }, [open, initialIcons, initialLinks]);

  const toggleIcon = (platform) => {
    setSelectedIcons((prev) => ({
      ...prev,
      [platform]: !prev[platform],
    }));
  };

  const handleLinkChange = (platform, value) => {
    setTempLinks((prev) => ({
      ...prev,
      [platform]: value,
    }));
  };

  const handleSave = () => {
    const confirmedIcons = Object.keys(selectedIcons).filter(
      (key) => selectedIcons[key]
    );
    onConfirm(confirmedIcons, tempLinks);
    onClose();
  };

  return (
    <DialogConfirmWrapper
      openPopup={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "600px",
          height: "500px",
          maxWidth: "none",
        },
      }}
      titleMessage={t("labels.social_media")}
      popupMessage={
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {socialPlatforms.map(({ key, icon: Icon, color, placeholder }) => (
            <Box
              key={key}
              sx={{ display: "flex", alignItems: "center", gap: 2 }}
            >
              <IconButton onClick={() => toggleIcon(key)}>
                <Icon
                  sx={{
                    color: selectedIcons[key] ? color : "gray",
                    fontSize: 40,
                  }}
                />
              </IconButton>
              {selectedIcons[key] && (
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder={`${placeholder}`}
                  value={tempLinks[key] || ""}
                  onChange={(e) => handleLinkChange(key, e.target.value)}
                  sx={{ width: "100%" }}
                />
              )}
            </Box>
          ))}
        </Box>
      }
      confirmLabel={t("labels.confirm")}
      onConfirm={handleSave}
    />
  );
};

export default SocialMediaDialog;
